<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="solicitante.reguladores"
            sort-by="infraestruturaNome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalExame.open(item)"
                    color="info"
                    small
                    title="Exames"
                >
                    <rkm-icon icon="dna" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalProcedimentoCirurgico.open(item)"
                    color="info"
                    small
                    title="Procedimentos cirúrgicos"
                >
                    <rkm-icon icon="pump-medical" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEspecialidade.open(item)"
                    color="info"
                    small
                    title="Especialidades"
                >
                    <rkm-icon icon="book-medical" />
                </rkm-button>

                <rkm-button
                    :disabled="item.hasSolicitacao"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalExame
            :data="data"
            ref="ModalExame"
        />

        <ModalProcedimentoCirurgico
            :data="data"
            ref="ModalProcedimentoCirurgico"
        />

        <ModalEspecialidade
            :data="data"
            ref="ModalEspecialidade"
        />
    </div>
</template>

<script>
// Components.
import ModalExame from './components/exame/Modal'
import ModalProcedimentoCirurgico from './components/procedimento-cirurgico/Modal'
import ModalEspecialidade from './components/especialidade/Modal'

export default {
    components: { ModalExame, ModalProcedimentoCirurgico, ModalEspecialidade },
    data: () => ({
        fields: [
            { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
            { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(regulador) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o regulador?',
                async () => this.solicitante.reguladores.splice(this.solicitante.reguladores.indexOf(regulador), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
        solicitante: { type: Object, required: true },
    }
}
</script>